import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import CollapsibleHeader from '../../../layout/CollapsibleHeader';
import ExcessBaggageTable from './ExcessBaggageTable';
import { excessBaggageSummaryPropTypes } from './SalesSessionPropTypes';
import { numberFormatter } from '../../../../utils/number';
import Table from '../../../common/Table';
import Badge from '../../../common/Badge';
import { generateSalesSessionExcessBaggageDownloadEndpoint } from '../../../../config/endpoints';

const ExcessBaggageSummary = ({
  excessBaggageSummaryList,
  salesSessionId,
  excessBaggagePaymentMethodSummaryList,
}) => {
  const clearVoucherPrefix = (serie) => {
    if (serie && (serie.startsWith('B') || serie.startsWith('F'))) {
      return serie.substring(1);
    }
    return serie;
  };

  const getParsedDocumentSeries = (excessBaggageSummary) => {
    if (excessBaggageSummary.contingency) {
      return clearVoucherPrefix(excessBaggageSummary.documentSeries);
    }
    return excessBaggageSummary.documentSeries;
  };

  if (excessBaggageSummaryList.length === 0) return null;

  let totalAmount = 0;
  excessBaggagePaymentMethodSummaryList.forEach((excessBaggage) => {
    totalAmount += excessBaggage.totalAmount;
  });

  let table = null;
  if (excessBaggageSummaryList.length > 0)
    table = (
      <div className="mb-3">
        <Row>
          <Col>
            <Table
              key={excessBaggageSummaryList.length}
              columns={[
                {
                  Header: 'Tipo de Comprobante de Pago',
                  accessor: 'voucherType',
                  className: 'text-center',
                  Cell: (row) => {
                    if (row.original.contingency) {
                      const text = row.value.replace(/electronica/gi, '');
                      return (
                        <>
                          {text} -{' '}
                          <Badge
                            className="bg-secondary text-white"
                            text="Contingencia"
                          />
                        </>
                      );
                    }
                    return <>{row.value}</>;
                  },
                },
                {
                  Header: 'Serie',
                  accessor: 'documentSeries',
                  className: 'text-center',
                  // eslint-disable-next-line
                  Cell: (row) => {
                    return getParsedDocumentSeries(row.original);
                  },
                },
                {
                  Header: 'Total de Ventas',
                  accessor: 'activeExcessBaggageAmount',
                  Cell: ({ value }) => numberFormatter({ value }),
                  Footer: (row) =>
                    `Total: ${numberFormatter({
                      value: row.data.reduce(
                        (accumulated, data) =>
                          accumulated + data.activeExcessBaggageAmount,
                        0,
                      ),
                    })}`,
                  className: 'text-right',
                },
              ]}
              data={excessBaggageSummaryList}
              defaultPageSize={excessBaggageSummaryList.length}
              showPagination={false}
            />
          </Col>
        </Row>
      </div>
    );

  return (
    <>
      <hr />
      <CollapsibleHeader
        headerText="Exceso de Equipajes"
        component={ExcessBaggageTable}
        salesSessionId={salesSessionId}
        downloadButton
        downloadEndpoint={generateSalesSessionExcessBaggageDownloadEndpoint}
        downloadLabel="Descargar exceso de equipajes"
      />
      {table}
      {excessBaggagePaymentMethodSummaryList.map((paymentMethod) => (
        <ResourceProperty
          key={paymentMethod.moneyFlowConcept}
          label={`${paymentMethod.moneyFlowConcept}: `}
        >
          {numberFormatter({ value: paymentMethod.totalAmount })}
        </ResourceProperty>
      ))}
      <ResourceProperty label="Total de Ventas por Exceso de Equipaje: ">
        {numberFormatter({ value: totalAmount })}
      </ResourceProperty>
    </>
  );
};

ExcessBaggageSummary.propTypes = {
  excessBaggageSummaryList: excessBaggageSummaryPropTypes.isRequired,
  salesSessionId: PropTypes.number.isRequired,
  excessBaggagePaymentMethodSummaryList: PropTypes.arrayOf(
    PropTypes.shape({
      moneyFlowConcept: PropTypes.string.isRequired,
      totalAmount: PropTypes.number.isRequired,
    }),
  ),
};

ExcessBaggageSummary.defaultProps = {
  excessBaggagePaymentMethodSummaryList: [],
};

export default ExcessBaggageSummary;
